"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ExternalToInternalEnumMappings_1 = require("../../EnumMappings/ExternalToInternalEnumMappings");
const ErrorHelpers_1 = require("../../Utils/ErrorHelpers");
const ServiceImplBase_1 = require("./ServiceImplBase");
class AnimationServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "animation-service" /* Animation */;
    }
    replayAsync(replaySpeed) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.ReplaySpeed]: 1.0,
        };
        ErrorHelpers_1.ErrorHelpers.verifyEnumValue(replaySpeed, api_external_contract_js_1.ReplaySpeedType, 'ReplaySpeedType');
        parameters[api_internal_contract_js_1.ParameterId.ReplaySpeed] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.setReplaySpeedType.convert(replaySpeed);
        return this.execute(api_internal_contract_js_1.VerbId.ReplayAnimation, parameters).then((response) => {
            return;
        });
    }
}
exports.AnimationServiceImpl = AnimationServiceImpl;
//# sourceMappingURL=AnimationServiceImpl.js.map